import request from '@/utilsCloud/request'
import port from './port'

// 获取课程一级分类
export function getCourseCatetoryPatentFromHome(query) {
  return request({
    url: port.course + '/home/getCourseCatetoryPatentFromHome',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取课程二级分类
export function getCourseCatetorySubsetFromHome(query) {
  return request({
    url: port.course + '/home/getCourseCatetorySubsetFromHome',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取课程库列表
export function getStudyCentreList(query) {
  return request({
    url: port.course + '/home/getStudyCentreList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/apiCloud/publicCourse.js